import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconEyeHide = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13.6875 5.25L6 12.9375C6.46875 13.0313 7.03125 13.125 7.5 13.125C10.875 13.125 13.5 10.2188 14.625 8.53125C15.0938 7.875 15.0938 7.03125 14.625 6.375C14.4375 6.09375 14.0625 5.71875 13.6875 5.25Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M13.4062 0.28125L10.875 2.8125C9.84375 2.25 8.71875 1.875 7.5 1.875C4.125 1.875 1.5 4.78125 0.375 6.46875C-0.09375 7.125 -0.09375 7.96875 0.375 8.53125C0.84375 9.28125 1.6875 10.2188 2.625 11.0625L0.28125 13.4062C-0.09375 13.7812 -0.09375 14.3438 0.28125 14.7188C0.46875 14.9062 0.65625 15 0.9375 15C1.21875 15 1.40625 14.9062 1.59375 14.7188L14.7188 1.59375C15.0938 1.21875 15.0938 0.65625 14.7188 0.28125C14.3438 -0.09375 13.7812 -0.09375 13.4062 0.28125ZM4.96875 8.71875C4.78125 8.34375 4.6875 7.96875 4.6875 7.5C4.6875 5.90625 5.90625 4.6875 7.5 4.6875C7.96875 4.6875 8.34375 4.78125 8.71875 4.96875L4.96875 8.71875Z",
		fill: "currentColor"
	})]
});
export default SvgIconEyeHide;
